import breakpoints from 'rp-mq-breakpoints';
import { BREAKPOINTS_SWITCH } from './breakpoints.actions';

export default (
    state = {
        current: breakpoints.current(),
        previous: breakpoints.current(),
    },
    action
) => {
    switch (action.type) {
        case BREAKPOINTS_SWITCH:
            return {
                current: action.payload.breakpoint,
                previous: action.payload.breakpointPrevious
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/js/Breakpoints/breakpoints.reducer.js